module.exports = __webpack_public_path__ + "img/cleaner5.7901287a.png";